import React, { useEffect } from 'react'
import Navbar from 'src/components/Navbar/Navbar'
import Footer from 'src/components/Footer/Footer'
import NoticesContent from 'src/components/NoticesContent/OpportunitiesContent'

const OpportunitiesPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <>
      <Navbar />
      <NoticesContent />
      <Footer />
    </>
  )
}

export default OpportunitiesPage
